type Data<T> = {
    [K in keyof T]: T[K] extends boolean | string | null ? T[K] : never;
};

type Labels = { [key: string]: string };

export function getListFromCheckboxAndText(data: Data<unknown>, labels: Labels) {
    const checkedOptions: string[] = [];

    if (!data) {
        return checkedOptions;
    }

    for (const [key, value] of Object.entries(data)) {
        if (value === true) {
            checkedOptions.push(labels[key]);
        } else if (typeof value === 'string' && value) {
            checkedOptions.push(value);
        }
    }

    return checkedOptions;
}
